// @ts-strict

import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-label-container',
  templateUrl: './label-container.component.html',
  styleUrls: ['./label-container.component.scss']
})
export class LabelContainerComponent {
  @Input() id: number = 0;
  @Input() icon: string = '';
  @Input() active: boolean = false;

  @Output() selectedSource: EventEmitter<{ id: number }> = new EventEmitter();

  constructor() {}

  public onSelect(): void {
    this.selectedSource.emit({ id: this.id });
  }

  public setSocialMediaIcon(): string {
    return `/assets/social_media/${this.icon}.png`;
  }

  public getBgClass(icon: string): string {
    switch (icon) {
      case 'youtube':
      case 'google-plus':
      case 'pinterest':
      case 'weibo':
        return 'background-red';
      case 'snapchat':
        return 'background-orange';
      case 'facebook':
      case 'tumblr':
      case 'twitter':
      case 'vimeo':
      case 'vk':
        return 'background-cyan';
      case 'tiktok':
      case 'myspace':
      case 'telegram':
      case 'linkedin':
        return 'background-turquoise';
      case 'whatsapp':
        return 'background-primary';
      case 'instagram':
      case 'reddit':
      case 'askfm':
      case 'qzone':
        return 'background-amber';
      case 'discord':
      case 'flickr':
        return 'background-purple';
      default:
        return '';
    }
  }
}
